import { RequestListContext } from '@Components/types/RequestListContext';
import { NoData } from '@Components/RequestList/noData';
import {
  PriceSelectionItemDto,
  TenderSupplier,
} from '@Features/MaterialRequest/requests/components/ComparisonSheet/ComparisonSheet.types';

import Card from './components/Card';
import styles from './request-list-mobile.module.css';

export interface RequestListMobileProps {
  vendors: TenderSupplier[];
  dataSource: PriceSelectionItemDto[];
  context?: RequestListContext;
}

const RequestListMobile = ({
  vendors,
  dataSource,
  context = 'my-requests',
}: RequestListMobileProps): JSX.Element | null => {
  if (!dataSource || !dataSource?.length) {
    return <NoData context={context} />;
  }

  return (
    <div className={styles.requestListMobile}>
      {dataSource.map((selectedItem) => {
        const { material, id, vendorOffers } = selectedItem;
        const vendorDetails = vendors.map((vendor) => {
          const vendorInfo = vendorOffers.find(
            (vendorOffer) => vendorOffer.vendorId === vendor.id
          );
          return { ...vendor, ...vendorInfo };
        });

        return (
          <Card
            key={id}
            unitName={material?.unit || ''}
            qty={material?.requiredQty}
            description={material?.description || ''}
            no={material?.code || ''}
            vendorDetails={vendorDetails}
          />
        );
      })}
    </div>
  );
};

export default RequestListMobile;
